import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SideBar from "../SideBar/SideBar";
import "./Projects.css";
import ProjectDetails from "./ProjectDetails";

export default function Projects(props) {
  return (
    <Container className="h-100 bg-danger" id="projects" fluid>
      <Row className="h-100">
        <div className="d-none d-md-block bg-dark col-md-1 pr-0">
          <SideBar active="Projects" />
        </div>
        <div className="col-md pl-md-0 pt-4 bg-dark ng-md-margin" id="mobile-section-project">
          <div className="d-block text-light d-md-none">
            <h2 className="mt-3 mt-md-5 mb-md-4">
              My <span className="text-danger">Projects</span>
            </h2>
            <h6 className="mt-2">
              <span style={{ textIndent: "1rem" }}>
                Here are some of my projects worth mentioning most of them are
                completed with the help of the above mentioned skills of mine.
              </span>
              <span className="d-block d-md-none">
                Below are some of my projects
              </span>
            </h6>
          </div>
          <div className="project-details">
            <ProjectDetails />
          </div>
          <div className="mt-5 d-md-none d-block text-center pb-3 pb-md-0 pt-md-5">
            <div className="mt-md-5 pt-md-5" />
            <Link
              className="mt-5 pt-md-5 text-light"
              to="/certifications"
              id="arrow-down"
            >
              <i className="mt-md-5 pt-md-5 fa-2x fa-solid fa-angles-down"></i>
            </Link>
          </div>
        </div>
        <div className="col-md-4 bg-danger d-none d-md-block text-light mt-5">
          <h2 className="mt-3 mt-md-5 mb-md-4">
            My Projects
          </h2>
          <h6 className="mt-2">
            <span style={{ textIndent: "1rem" }}>
              Here are some of my projects worth mentioning most of them are
              completed with the help of the above mentioned skills of mine.
            </span>
            <span className="d-block d-md-none">
              Below are some of my projects
            </span>
          </h6>
          <div className="mt-5 text-center pb-3 pb-md-0 pt-md-5">
            <div className="mt-md-5 pt-md-5" />
            <div className="mt-md-3" />
            <Link
              className="mt-5 pt-md-5 text-light"
              to="/certifications"
              id="arrow-down"
            >
              <i className="mt-md-5 pt-md-5 fa-2x fa-solid fa-angles-down"></i>
            </Link>
          </div>
        </div>
      </Row>
    </Container>
  );
}
